module.exports = "/assets/career/team/krzaczek.png?AU4Ra5p";